'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegionSideStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  regionAsideMaxWidth: _propTypes2.default.number,
  theme: _propTypes2.default.object
};

var defaultProps = {
  regionAsideMaxWidth: null
};

/** Prop Receivers */
var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme,
      regionAsideMaxWidth = _ref.regionAsideMaxWidth;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.dialog.sideRegion,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      maxWidth = _theme$reactackle$com.maxWidth;
  var borderRadius = theme.reactackle.components.dialog.window.borderRadius,
      asideMaxWidthSrc = regionAsideMaxWidth || maxWidth;


  return (0, _styledComponents.css)(['background-color:', ';max-width:', ';', ''], backgroundColor, (0, _reactackleCore.getValueString)(asideMaxWidthSrc), (0, _reactackleCore.sideRadius)('right', '' + (0, _reactackleCore.getValueString)(borderRadius)));
};

/** Styles */
var RegionSideStyled = exports.RegionSideStyled = _styledComponents2.default.div.withConfig({
  displayName: 'RegionSideStyled'
})(['flex-shrink:0;display:flex;align-items:stretch;', ';'], baseProps);

RegionSideStyled.propTypes = propTypes;
RegionSideStyled.defaultProps = defaultProps;
RegionSideStyled.displayName = 'RegionSideStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/styles/RegionSideStyled.js
// module id = 669
// module chunks = 0